import { parseDate } from "data/lib/dates"
import propertyReportService from "data/reports-property"
// Data
import underwritingService from "data/underwriting"
import _ from 'lodash'
import calcService from "data/calc"
import React, { FC, useEffect, useState } from "react"
// Styles
import { ButtonWithPress_s, Label_s } from "styles/app-styles"
import { DateText_s, ReportForm_s } from "styles/report-styles"

interface Props {
  property: object
}

const TenantMarketComparison: FC<Props> = (props) => {
  const [start_month, setStartMonth] = useState<string>(underwritingService.getReportBeginDefault(true, null, true))

  useEffect(() => {
    setStartMonth(underwritingService.getReportBeginDefault(true, null, true));
  }, [props['property']])

  function submit():void {
    propertyReportService.propertyReport({
      report: 'current_revenue_market',
      params: {
        begindate: underwritingService.toISOdate(start_month),
      }
    });
  }

  const disabled = !calcService.calcCheck(props.property)
  const buttonText = disabled ? 'Calculation Required' : 'Run Report'

  return (
    <div>
      <ButtonWithPress_s primary onClick={submit} style={{marginBottom: 20}} disabled={disabled}>{buttonText}</ButtonWithPress_s>
      <ReportForm_s>
        <div>
          <Label_s>Start Date</Label_s>
          <DateText_s withoutDays value={parseDate(start_month).format('MM/DD/YYYY')} onChange={setStartMonth} onBlur={setStartMonth} persist={setStartMonth} />
        </div>
      </ReportForm_s>
    </div>
  )
}

export default TenantMarketComparison
